module.exports = ".tooltip-handling\n{\n   width: 86%;\n   position: relative;\n}\n.eligibility-page-form .tooltip-handling {\n    width: 89%;\n}\n.drop-tooltip {\n    right: -44px;\n    border-bottom: 2px solid black;\n    padding-left: 0;\n    top: 2px;\n}\n.fa-caret-down:before{\n    content: \"\" !important;\n    width: 0;\n    height: 0;\n    /* border: 5px solid transparent; */\n    border-color: black transparent transparent transparent;\n    position: absolute;\n    top: 15px;\n    right: 6px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/multi-select-dropdown.component/multi-select-dropdown.component.css
// module id = 531
// module chunks = 2